import React from "react";
import "./article.css";

const Article = ({ imgUrl, date, title }) => {
  return (
    <div className="webpage__blog-container_article">
      <div className="webpage__blog-container_article-image">
        <img src={imgUrl} alt="blog " />
      </div>
      <div className="webpage__blog-container_article-content">
        <div>
          <p>{date}</p>
          <h3>{title}</h3>
        </div>
        <p>Reall all the article please da</p>
      </div>
    </div>
  );
};

export default Article;
